import { __extends } from 'tslib';
import classNames from 'classnames';
import React__default from 'react';
import { DeepPureComponent } from '../Component.js';
import styles from './ButtonSwitch.module.scss.js';

var ButtonSwitch = (function (_super) {
    __extends(ButtonSwitch, _super);
    function ButtonSwitch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getOnText = function () {
            if (_this.props.value) {
                return _this.props.stateTextOn ? _this.props.stateTextOn[1] : 'on';
            }
            else {
                return _this.props.stateTextOn ? _this.props.stateTextOn[0] : 'on';
            }
        };
        _this.getOffText = function () {
            if (_this.props.value) {
                return _this.props.stateTextOff ? _this.props.stateTextOff[0] : 'off';
            }
            else {
                return _this.props.stateTextOff ? _this.props.stateTextOff[1] : 'off';
            }
        };
        _this.turnOn = function () {
            if (!_this.props.value && _this.props.onChange) {
                _this.props.onChange(true);
            }
        };
        _this.turnOff = function () {
            if (_this.props.value && _this.props.onChange) {
                _this.props.onChange(false);
            }
        };
        return _this;
    }
    ButtonSwitch.prototype.render = function () {
        return (React__default.createElement("div", { className: classNames(styles.wrapper, this.props.className) },
            React__default.createElement("div", { className: styles.inner },
                React__default.createElement("div", { className: styles.activeBgOn + " " + (!this.props.value ? styles.activeBgOff : '') }),
                React__default.createElement("div", { className: styles.button + " " + styles.buttonOn + " " + (this.props.value ? styles.buttonOnActive : '') + " ", onClick: this.turnOn }, this.getOnText()),
                React__default.createElement("div", { className: styles.button + " " + styles.buttonOff + " " + (!this.props.value ? styles.buttonOffActive : ''), onClick: this.turnOff }, this.getOffText()))));
    };
    return ButtonSwitch;
}(DeepPureComponent));

export { ButtonSwitch as default };
//# sourceMappingURL=ButtonSwitch.js.map
